import { AUTH_EMAIL_LOGIN } from 'portal/constants/Routes';
import {
  buttonContainerStyles,
  buttonStyles,
  ctaContainerStyles,
  linkButtonStyles,
  loginContainerStyles
} from 'auth/AuthStyles';
import { SET_DATA } from 'helpers/Constants';
import { useDispatch, useSelector } from 'react-redux';
import AuthLayout from 'auth/AuthLayout';
import Button from '@opploans/button-component/Button';
import LinkButton from '@opploans/link-button-component/LinkButton';
import React from 'react';
import RebrandBasicSocialSecurity from 'fields/rebrand/RebrandBasicSocialSecurity';

function AuthSsnVerification({ navigate }) {
  const dispatch = useDispatch();
  const errors = useSelector((state) => state.errors);

  const onSsnConfirm = async () => {
    dispatch({ type: SET_DATA, payload: { ssnConfirmed: true } });
  };

  return (
    <AuthLayout
      title="Let's Verify Your Identity"
      subTitle='For your security, enter your social security number to verify your identity.'
      subHeaderStyles={{ textAlign: 'center' }}
    >
      <div>
        <div css={loginContainerStyles}>
          <div
            role='button'
            aria-hidden='true'
            onKeyPress={(e) => {
              if (
                e.key === 'Enter' &&
                errors.socialSecurityNumber !== undefined &&
                !errors.socialSecurityNumber
              ) {
                onSsnConfirm();
              }
            }}
          >
            <RebrandBasicSocialSecurity />
            <div css={buttonContainerStyles}>
              <Button
                css={[buttonStyles, { marginTop: '1rem' }]}
                onClick={onSsnConfirm}
                disabled={
                  errors.socialSecurityNumber === undefined ||
                  !!errors.socialSecurityNumber
                }
              >
                Confirm
              </Button>
            </div>
          </div>
        </div>

        <div css={ctaContainerStyles}>
          <LinkButton
            lightBackground
            additionalStyle={linkButtonStyles}
            onClick={() => navigate(AUTH_EMAIL_LOGIN)}
          >
            Return to login with email and password
          </LinkButton>
        </div>
      </div>
    </AuthLayout>
  );
}
export default AuthSsnVerification;
